import { FC } from "react";

import { TaskDriverStatusEnum } from "@/domain/models/common";
import { useTranslator } from "@/i18n/useTranslator";

import { DriverFlowBottomButton, PhoneCallButton } from "../blocks";
import { DsDataDisplay, DsText } from "../components/ui";
import { useUpdateServiceMutation } from "../data/mutations/serviceMutations";
import { useUpdateTaskMutation } from "../data/mutations/taskMutations";
import { useJobQuery } from "../data/queries/jobQueries";
import { JobServiceTaskBaseType } from "../domain/task";
import { CustomerNameText } from "./CustomerNameText";

const DriverStepDumpAndReturnDrivingToDump: FC<JobServiceTaskBaseType> = ({
  jobId,
  serviceId,
  taskId,
}) => {
  const { t } = useTranslator();

  const { data: jobData } = useJobQuery({ jobId });

  const {
    mutate: updateService,
    isPending: isUpdatingService,
    variables,
  } = useUpdateServiceMutation();
  const { mutate: updateTask, isPending: isUpdatingTask } =
    useUpdateTaskMutation();

  const onNextClick = () => {
    updateService({
      serviceId,
      jobId,
      driverFlowStatus: TaskDriverStatusEnum.FILLING_WEIGHT_SURCHARGE,
    });

    updateTask({
      jobId,
      serviceId,
      taskId,
      driverFlowStatus: TaskDriverStatusEnum.FILLING_WEIGHT_SURCHARGE,
    });
  };

  const isLoading = isUpdatingService || isUpdatingTask;

  const isNextButtonLoading =
    isLoading &&
    variables?.driverFlowStatus ===
      TaskDriverStatusEnum.FILLING_WEIGHT_SURCHARGE;

  const contactName = jobData?.site?.contact?.name ?? "";
  const contactPhone = jobData?.site?.contact?.phone ?? "";

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex flex-grow w-full flex-col justify-center">
        <DsText className="mb-2" variant="pageTitle">
          {t("driver_wait_and_load_driving_to_dump.title")}
        </DsText>
        <DsDataDisplay
          title="driver_task_details.customer"
          data={
            <CustomerNameText
              jobId={jobId}
              serviceId={serviceId}
              variant="dataDisplayValue"
              className="font-bold"
            />
          }
        />
        <DsDataDisplay
          title="driver_task_details.job_contact"
          shouldShowBorderBottom={false}
          data={
            <PhoneCallButton
              phoneNumber={contactPhone?.toString() ?? ""}
              title={contactName}
            />
          }
        />
      </div>
      <DriverFlowBottomButton
        onNextButtonClick={onNextClick}
        isNextButtonLoading={isNextButtonLoading}
        nextButtonTitle="driver_wait_and_load_driving_to_dump.next_button"
      />
    </div>
  );
};

export { DriverStepDumpAndReturnDrivingToDump };
